const AOI_GRAVEL_PRODUCT_URL = '/products/aoi-gravel-sram-rival-12a';
const AOI_GRAVEL_IMAGE_URL = document.currentScript?.dataset.gravelImage;
const AOI_GRAVEL_LINK_LABELS = new Set(['gravel', 'sram rival 12a']);
const AOI_GRAVEL_COLLECTION_PATHS = new Set(['/collections/gravel']);
const AOI_LEGACY_IMAGE_URL =
  'https://aoi-cycle.myshopify.com/cdn/shop/files/aoi-3633-legacy-cl.jpg?v=1787199477';

function pointGravelLinksToProduct(root = document) {
  root.querySelectorAll('a[href]').forEach((link) => {
    const label = link.textContent.trim().replace(/\s+/g, ' ').toLowerCase();
    const cardTitle = link.querySelector('h3')?.textContent.trim().toLowerCase();
    const url = new URL(link.href, window.location.origin);

    if (link.matches('.aoi-card')) {
      link.querySelector(':scope > div')?.style.setProperty('border-top', '0');
    }

    if (AOI_GRAVEL_LINK_LABELS.has(label) || AOI_GRAVEL_COLLECTION_PATHS.has(url.pathname)) {
      link.href = AOI_GRAVEL_PRODUCT_URL;
    }

    if (cardTitle === 'gravel' && link.matches('.aoi-card') && AOI_GRAVEL_IMAGE_URL) {
      const image = link.querySelector('img');
      if (image) {
        image.src = AOI_GRAVEL_IMAGE_URL;
        image.removeAttribute('srcset');
        image.style.removeProperty('clip-path');
        image.width = 1254;
        image.height = 1254;
        image.alt = 'AOI Gravel SRAM Rival 12A stainless steel bicycle';
      }
    }

    if (url.pathname === '/collections/legacy' && link.matches('.aoi-card')) {
      const image = link.querySelector('img');
      if (image) {
        image.src = `${AOI_LEGACY_IMAGE_URL}&width=900`;
        image.srcset = [
          `${AOI_LEGACY_IMAGE_URL}&width=480 480w`,
          `${AOI_LEGACY_IMAGE_URL}&width=720 720w`,
          `${AOI_LEGACY_IMAGE_URL}&width=900 900w`,
          `${AOI_LEGACY_IMAGE_URL}&width=1200 1200w`,
        ].join(', ');
        image.sizes = '(max-width: 767px) 100vw, (max-width: 1100px) 50vw, 25vw';
        image.width = 1200;
        image.height = 1200;
        image.alt = 'AOI LEGACY - Classic';
      }
    }
  });

  root.querySelectorAll('.aoi-grid--4').forEach((grid) => {
    const cards = Array.from(grid.querySelectorAll(':scope > .aoi-card'));
    const cardsByTitle = new Map(
      cards.map((card) => [card.querySelector('h3')?.textContent.trim().toLowerCase(), card])
    );
    const orderedCards = ['legacy', 'copenhagen', 'gravel', 'wild miudy']
      .map((title) => cardsByTitle.get(title))
      .filter(Boolean);

    if (
      orderedCards.length === 4 &&
      orderedCards.some((card, index) => cards[index] !== card)
    ) {
      orderedCards.forEach((card) => grid.append(card));
    }
  });
}

pointGravelLinksToProduct();

new MutationObserver(() => pointGravelLinksToProduct()).observe(document.documentElement, {
  childList: true,
  subtree: true,
});
